import React from 'react'

import JO_Archery_en from '../../node/static/assets/JO_Archery_en.svg'
import JO_Archery_fr from '../../node/static/assets/JO_Archery_fr.svg'
import JO_ArtisticGymnastics_en from '../../node/static/assets/JO_ArtisticGymnastics_en.svg'
import JO_ArtisticGymnastics_fr from '../../node/static/assets/JO_ArtisticGymnastics_fr.svg'
import JO_ArtisticSwimming_en from '../../node/static/assets/JO_ArtisticSwimming_en.svg'
import JO_ArtisticSwimming_fr from '../../node/static/assets/JO_ArtisticSwimming_fr.svg'
import JO_Athletics_en from '../../node/static/assets/JO_Athletics_en.svg'
import JO_Athletics_fr from '../../node/static/assets/JO_Athletics_fr.svg'
import JO_BMXfreestyle_en from '../../node/static/assets/JO_BMXfreestyle_en.svg'
import JO_BMXfreestyle_fr from '../../node/static/assets/JO_BMXfreestyle_fr.svg'
import JO_BMXracing_en from '../../node/static/assets/JO_BMXracing_en.svg'
import JO_BMXracing_fr from '../../node/static/assets/JO_BMXracing_fr.svg'
import JO_Badminton_en from '../../node/static/assets/JO_Badminton_en.svg'
import JO_Badminton_fr from '../../node/static/assets/JO_Badminton_fr.svg'
import JO_Basketball3x3_en from '../../node/static/assets/JO_Basketball3x3_en.svg'
import JO_Basketball3x3_fr from '../../node/static/assets/JO_Basketball3x3_fr.svg'
import JO_Basketball_en from '../../node/static/assets/JO_Basketball_en.svg'
import JO_Basketball_fr from '../../node/static/assets/JO_Basketball_fr.svg'
import JO_BeachVolleyball_en from '../../node/static/assets/JO_BeachVolleyball_en.svg'
import JO_BeachVolleyball_fr from '../../node/static/assets/JO_BeachVolleyball_fr.svg'
import JO_BlindFootball_en from '../../node/static/assets/JO_BlindFootball_en.svg'
import JO_BlindFootball_fr from '../../node/static/assets/JO_BlindFootball_fr.svg'
import JO_Boccia_en from '../../node/static/assets/JO_Boccia_en.svg'
import JO_Boccia_fr from '../../node/static/assets/JO_Boccia_fr.svg'
import JO_Boxing_en from '../../node/static/assets/JO_Boxing_en.svg'
import JO_Boxing_fr from '../../node/static/assets/JO_Boxing_fr.svg'
import JO_Breaking_en from '../../node/static/assets/JO_Breaking_en.svg'
import JO_Breaking_fr from '../../node/static/assets/JO_Breaking_fr.svg'
import JO_CanoeSlalom_en from '../../node/static/assets/JO_CanoeSlalom_en.svg'
import JO_CanoeSlalom_fr from '../../node/static/assets/JO_CanoeSlalom_fr.svg'
import JO_CanoeSprint_en from '../../node/static/assets/JO_CanoeSprint_en.svg'
import JO_CanoeSprint_fr from '../../node/static/assets/JO_CanoeSprint_fr.svg'
import JO_CyclingTrack_en from '../../node/static/assets/JO_CyclingTrack_en.svg'
import JO_CyclingTrack_fr from '../../node/static/assets/JO_CyclingTrack_fr.svg'
import JO_Diving_en from '../../node/static/assets/JO_Diving_en.svg'
import JO_Diving_fr from '../../node/static/assets/JO_Diving_fr.svg'
import JO_Equestrian_en from '../../node/static/assets/JO_Equestrian_en.svg'
import JO_Equestrian_fr from '../../node/static/assets/JO_Equestrian_fr.svg'
import JO_Fencing_en from '../../node/static/assets/JO_Fencing_en.svg'
import JO_Fencing_fr from '../../node/static/assets/JO_Fencing_fr.svg'
import JO_Football_en from '../../node/static/assets/JO_Football_en.svg'
import JO_Football_fr from '../../node/static/assets/JO_Football_fr.svg'
import JO_Goalball_en from '../../node/static/assets/JO_Goalball_en.svg'
import JO_Goalball_fr from '../../node/static/assets/JO_Goalball_fr.svg'
import JO_Golf_en from '../../node/static/assets/JO_Golf_en.svg'
import JO_Golf_fr from '../../node/static/assets/JO_Golf_fr.svg'
import JO_Handball_en from '../../node/static/assets/JO_Handball_en.svg'
import JO_Handball_fr from '../../node/static/assets/JO_Handball_fr.svg'
import JO_Hockey_en from '../../node/static/assets/JO_Hockey_en.svg'
import JO_Hockey_fr from '../../node/static/assets/JO_Hockey_fr.svg'
import JO_Judo_en from '../../node/static/assets/JO_Judo_en.svg'
import JO_Judo_fr from '../../node/static/assets/JO_Judo_fr.svg'
import JO_MarathonSwimming_en from '../../node/static/assets/JO_MarathonSwimming_en.svg'
import JO_MarathonSwimming_fr from '../../node/static/assets/JO_MarathonSwimming_fr.svg'
import JO_ModernPentathlon_en from '../../node/static/assets/JO_ModernPentathlon_en.svg'
import JO_ModernPentathlon_fr from '../../node/static/assets/JO_ModernPentathlon_fr.svg'
import JO_MountainBike_en from '../../node/static/assets/JO_MountainBike_en.svg'
import JO_MountainBike_fr from '../../node/static/assets/JO_MountainBike_fr.svg'
import JO_ParaArchery_en from '../../node/static/assets/JO_ParaArchery_en.svg'
import JO_ParaArchery_fr from '../../node/static/assets/JO_ParaArchery_fr.svg'
import JO_ParaAthletics_en from '../../node/static/assets/JO_ParaAthletics_en.svg'
import JO_ParaAthletics_fr from '../../node/static/assets/JO_ParaAthletics_fr.svg'
import JO_ParaBadminton_en from '../../node/static/assets/JO_ParaBadminton_en.svg'
import JO_ParaBadminton_fr from '../../node/static/assets/JO_ParaBadminton_fr.svg'
import JO_ParaCanoe_en from '../../node/static/assets/JO_ParaCanoe_en.svg'
import JO_ParaCanoe_fr from '../../node/static/assets/JO_ParaCanoe_fr.svg'
import JO_ParaCyclingRoad_en from '../../node/static/assets/JO_ParaCyclingRoad_en.svg'
import JO_ParaCyclingRoad_fr from '../../node/static/assets/JO_ParaCyclingRoad_fr.svg'
import JO_ParaCyclingTrack_en from '../../node/static/assets/JO_ParaCyclingTrack_en.svg'
import JO_ParaCyclingTrack_fr from '../../node/static/assets/JO_ParaCyclingTrack_fr.svg'
import JO_ParaEquestrian_en from '../../node/static/assets/JO_ParaEquestrian_en.svg'
import JO_ParaEquestrian_fr from '../../node/static/assets/JO_ParaEquestrian_fr.svg'
import JO_ParaJudo_en from '../../node/static/assets/JO_ParaJudo_en.svg'
import JO_ParaJudo_fr from '../../node/static/assets/JO_ParaJudo_fr.svg'
import JO_ParaPowerlifting_en from '../../node/static/assets/JO_ParaPowerlifting_en.svg'
import JO_ParaPowerlifting_fr from '../../node/static/assets/JO_ParaPowerlifting_fr.svg'
import JO_ParaRowing_en from '../../node/static/assets/JO_ParaRowing_en.svg'
import JO_ParaRowing_fr from '../../node/static/assets/JO_ParaRowing_fr.svg'
import JO_ParaSwimming_en from '../../node/static/assets/JO_ParaSwimming_en.svg'
import JO_ParaSwimming_fr from '../../node/static/assets/JO_ParaSwimming_fr.svg'
import JO_ParaTableTennis_en from '../../node/static/assets/JO_ParaTableTennis_en.svg'
import JO_ParaTableTennis_fr from '../../node/static/assets/JO_ParaTableTennis_fr.svg'
import JO_ParaTaekwondo_en from '../../node/static/assets/JO_ParaTaekwondo_en.svg'
import JO_ParaTaekwondo_fr from '../../node/static/assets/JO_ParaTaekwondo_fr.svg'
import JO_ParaTriathlon_en from '../../node/static/assets/JO_ParaTriathlon_en.svg'
import JO_ParaTriathlon_fr from '../../node/static/assets/JO_ParaTriathlon_fr.svg'
import JO_Paris_2024 from '../../node/static/assets/JO_Paris_2024.svg'
import JO_RhythmicGymnastics_en from '../../node/static/assets/JO_RhythmicGymnastics_en.svg'
import JO_RhythmicGymnastics_fr from '../../node/static/assets/JO_RhythmicGymnastics_fr.svg'
import JO_RoadCycling_en from '../../node/static/assets/JO_RoadCycling_en.svg'
import JO_RoadCycling_fr from '../../node/static/assets/JO_RoadCycling_fr.svg'
import JO_Rowing_en from '../../node/static/assets/JO_Rowing_en.svg'
import JO_Rowing_fr from '../../node/static/assets/JO_Rowing_fr.svg'
import JO_Rugby_en from '../../node/static/assets/JO_Rugby_en.svg'
import JO_Rugby_fr from '../../node/static/assets/JO_Rugby_fr.svg'
import JO_Sailing_en from '../../node/static/assets/JO_Sailing_en.svg'
import JO_Sailing_fr from '../../node/static/assets/JO_Sailing_fr.svg'
import JO_ShootingParaSport_en from '../../node/static/assets/JO_ShootingParaSport_en.svg'
import JO_ShootingParaSport_fr from '../../node/static/assets/JO_ShootingParaSport_fr.svg'
import JO_Shooting_en from '../../node/static/assets/JO_Shooting_en.svg'
import JO_Shooting_fr from '../../node/static/assets/JO_Shooting_fr.svg'
import JO_SittingVolleyball_en from '../../node/static/assets/JO_SittingVolleyball_en.svg'
import JO_SittingVolleyball_fr from '../../node/static/assets/JO_SittingVolleyball_fr.svg'
import JO_Skateboarding_en from '../../node/static/assets/JO_Skateboarding_en.svg'
import JO_Skateboarding_fr from '../../node/static/assets/JO_Skateboarding_fr.svg'
import JO_SportClimbing_en from '../../node/static/assets/JO_SportClimbing_en.svg'
import JO_SportClimbing_fr from '../../node/static/assets/JO_SportClimbing_fr.svg'
import JO_Swimming_en from '../../node/static/assets/JO_Swimming_en.svg'
import JO_Swimming_fr from '../../node/static/assets/JO_Swimming_fr.svg'
import JO_TableTennis_en from '../../node/static/assets/JO_TableTennis_en.svg'
import JO_TableTennis_fr from '../../node/static/assets/JO_TableTennis_fr.svg'
import JO_Taekwondo_en from '../../node/static/assets/JO_Taekwondo_en.svg'
import JO_Taekwondo_fr from '../../node/static/assets/JO_Taekwondo_fr.svg'
import JO_Tennis_en from '../../node/static/assets/JO_Tennis_en.svg'
import JO_Tennis_fr from '../../node/static/assets/JO_Tennis_fr.svg'
import JO_Trampoline_en from '../../node/static/assets/JO_Trampoline_en.svg'
import JO_Trampoline_fr from '../../node/static/assets/JO_Trampoline_fr.svg'
import JO_Triathlon_en from '../../node/static/assets/JO_Triathlon_en.svg'
import JO_Triathlon_fr from '../../node/static/assets/JO_Triathlon_fr.svg'
import JO_Volleyball_en from '../../node/static/assets/JO_Volleyball_en.svg'
import JO_Volleyball_fr from '../../node/static/assets/JO_Volleyball_fr.svg'
import JO_WaterPolo_en from '../../node/static/assets/JO_WaterPolo_en.svg'
import JO_WaterPolo_fr from '../../node/static/assets/JO_WaterPolo_fr.svg'
import JO_Weightlifting_en from '../../node/static/assets/JO_Weightlifting_en.svg'
import JO_Weightlifting_fr from '../../node/static/assets/JO_Weightlifting_fr.svg'
import JO_WheelchairBasketball_en from '../../node/static/assets/JO_WheelchairBasketball_en.svg'
import JO_WheelchairBasketball_fr from '../../node/static/assets/JO_WheelchairBasketball_fr.svg'
import JO_WheelchairFencing_en from '../../node/static/assets/JO_WheelchairFencing_en.svg'
import JO_WheelchairFencing_fr from '../../node/static/assets/JO_WheelchairFencing_fr.svg'
import JO_WheelchairRugby_en from '../../node/static/assets/JO_WheelchairRugby_en.svg'
import JO_WheelchairRugby_fr from '../../node/static/assets/JO_WheelchairRugby_fr.svg'
import JO_WheelchairTennis_en from '../../node/static/assets/JO_WheelchairTennis_en.svg'
import JO_WheelchairTennis_fr from '../../node/static/assets/JO_WheelchairTennis_fr.svg'
import JO_Wrestling_en from '../../node/static/assets/JO_Wrestling_en.svg'
import JO_Wrestling_fr from '../../node/static/assets/JO_Wrestling_fr.svg'

import SVGIcon from '../svg/SVGIcon'

const getSvgFromName = fileName => {
  switch (fileName) {
    case 'JO_Paris_2024':
      return JO_Paris_2024
    case 'JO_Archery_en':
      return JO_Archery_en
    case 'JO_Archery_fr':
      return JO_Archery_fr
    case 'JO_ArtisticGymnastics_en':
      return JO_ArtisticGymnastics_en
    case 'JO_ArtisticGymnastics_fr':
      return JO_ArtisticGymnastics_fr
    case 'JO_ArtisticSwimming_en':
      return JO_ArtisticSwimming_en
    case 'JO_ArtisticSwimming_fr':
      return JO_ArtisticSwimming_fr
    case 'JO_Athletics_en':
      return JO_Athletics_en
    case 'JO_Athletics_fr':
      return JO_Athletics_fr
    case 'JO_BMXfreestyle_en':
      return JO_BMXfreestyle_en
    case 'JO_BMXfreestyle_fr':
      return JO_BMXfreestyle_fr
    case 'JO_BMXracing_en':
      return JO_BMXracing_en
    case 'JO_BMXracing_fr':
      return JO_BMXracing_fr
    case 'JO_Badminton_en':
      return JO_Badminton_en
    case 'JO_Badminton_fr':
      return JO_Badminton_fr
    case 'JO_Basketball3x3_en':
      return JO_Basketball3x3_en
    case 'JO_Basketball3x3_fr':
      return JO_Basketball3x3_fr
    case 'JO_Basketball_en':
      return JO_Basketball_en
    case 'JO_Basketball_fr':
      return JO_Basketball_fr
    case 'JO_BeachVolleyball_en':
      return JO_BeachVolleyball_en
    case 'JO_BeachVolleyball_fr':
      return JO_BeachVolleyball_fr
    case 'JO_BlindFootball_en':
      return JO_BlindFootball_en
    case 'JO_BlindFootball_fr':
      return JO_BlindFootball_fr
    case 'JO_Boccia_en':
      return JO_Boccia_en
    case 'JO_Boccia_fr':
      return JO_Boccia_fr
    case 'JO_Boxing_en':
      return JO_Boxing_en
    case 'JO_Boxing_fr':
      return JO_Boxing_fr
    case 'JO_Breaking_en':
      return JO_Breaking_en
    case 'JO_Breaking_fr':
      return JO_Breaking_fr
    case 'JO_CanoeSlalom_en':
      return JO_CanoeSlalom_en
    case 'JO_CanoeSlalom_fr':
      return JO_CanoeSlalom_fr
    case 'JO_CanoeSprint_en':
      return JO_CanoeSprint_en
    case 'JO_CanoeSprint_fr':
      return JO_CanoeSprint_fr
    case 'JO_CyclingTrack_en':
      return JO_CyclingTrack_en
    case 'JO_CyclingTrack_fr':
      return JO_CyclingTrack_fr
    case 'JO_Diving_en':
      return JO_Diving_en
    case 'JO_Diving_fr':
      return JO_Diving_fr
    case 'JO_Equestrian_en':
      return JO_Equestrian_en
    case 'JO_Equestrian_fr':
      return JO_Equestrian_fr
    case 'JO_Fencing_en':
      return JO_Fencing_en
    case 'JO_Fencing_fr':
      return JO_Fencing_fr
    case 'JO_Football_en':
      return JO_Football_en
    case 'JO_Football_fr':
      return JO_Football_fr
    case 'JO_Goalball_en':
      return JO_Goalball_en
    case 'JO_Goalball_fr':
      return JO_Goalball_fr
    case 'JO_Golf_en':
      return JO_Golf_en
    case 'JO_Golf_fr':
      return JO_Golf_fr
    case 'JO_Handball_en':
      return JO_Handball_en
    case 'JO_Handball_fr':
      return JO_Handball_fr
    case 'JO_Hockey_en':
      return JO_Hockey_en
    case 'JO_Hockey_fr':
      return JO_Hockey_fr
    case 'JO_Judo_en':
      return JO_Judo_en
    case 'JO_Judo_fr':
      return JO_Judo_fr
    case 'JO_MarathonSwimming_en':
      return JO_MarathonSwimming_en
    case 'JO_MarathonSwimming_fr':
      return JO_MarathonSwimming_fr
    case 'JO_ModernPentathlon_en':
      return JO_ModernPentathlon_en
    case 'JO_ModernPentathlon_fr':
      return JO_ModernPentathlon_fr
    case 'JO_MountainBike_en':
      return JO_MountainBike_en
    case 'JO_MountainBike_fr':
      return JO_MountainBike_fr
    case 'JO_ParaArchery_en':
      return JO_ParaArchery_en
    case 'JO_ParaArchery_fr':
      return JO_ParaArchery_fr
    case 'JO_ParaAthletics_en':
      return JO_ParaAthletics_en
    case 'JO_ParaAthletics_fr':
      return JO_ParaAthletics_fr
    case 'JO_ParaBadminton_en':
      return JO_ParaBadminton_en
    case 'JO_ParaBadminton_fr':
      return JO_ParaBadminton_fr
    case 'JO_ParaCanoe_en':
      return JO_ParaCanoe_en
    case 'JO_ParaCanoe_fr':
      return JO_ParaCanoe_fr
    case 'JO_ParaCyclingRoad_en':
      return JO_ParaCyclingRoad_en
    case 'JO_ParaCyclingRoad_fr':
      return JO_ParaCyclingRoad_fr
    case 'JO_ParaCyclingTrack_en':
      return JO_ParaCyclingTrack_en
    case 'JO_ParaCyclingTrack_fr':
      return JO_ParaCyclingTrack_fr
    case 'JO_ParaEquestrian_en':
      return JO_ParaEquestrian_en
    case 'JO_ParaEquestrian_fr':
      return JO_ParaEquestrian_fr
    case 'JO_ParaJudo_en':
      return JO_ParaJudo_en
    case 'JO_ParaJudo_fr':
      return JO_ParaJudo_fr
    case 'JO_ParaPowerlifting_en':
      return JO_ParaPowerlifting_en
    case 'JO_ParaPowerlifting_fr':
      return JO_ParaPowerlifting_fr
    case 'JO_ParaRowing_en':
      return JO_ParaRowing_en
    case 'JO_ParaRowing_fr':
      return JO_ParaRowing_fr
    case 'JO_ParaSwimming_en':
      return JO_ParaSwimming_en
    case 'JO_ParaSwimming_fr':
      return JO_ParaSwimming_fr
    case 'JO_ParaTableTennis_en':
      return JO_ParaTableTennis_en
    case 'JO_ParaTableTennis_fr':
      return JO_ParaTableTennis_fr
    case 'JO_ParaTaekwondo_en':
      return JO_ParaTaekwondo_en
    case 'JO_ParaTaekwondo_fr':
      return JO_ParaTaekwondo_fr
    case 'JO_ParaTriathlon_en':
      return JO_ParaTriathlon_en
    case 'JO_ParaTriathlon_fr':
      return JO_ParaTriathlon_fr
    case 'JO_RhythmicGymnastics_en':
      return JO_RhythmicGymnastics_en
    case 'JO_RhythmicGymnastics_fr':
      return JO_RhythmicGymnastics_fr
    case 'JO_RoadCycling_en':
      return JO_RoadCycling_en
    case 'JO_RoadCycling_fr':
      return JO_RoadCycling_fr
    case 'JO_Rowing_en':
      return JO_Rowing_en
    case 'JO_Rowing_fr':
      return JO_Rowing_fr
    case 'JO_Rugby_en':
      return JO_Rugby_en
    case 'JO_Rugby_fr':
      return JO_Rugby_fr
    case 'JO_Sailing_en':
      return JO_Sailing_en
    case 'JO_Sailing_fr':
      return JO_Sailing_fr
    case 'JO_ShootingParaSport_en':
      return JO_ShootingParaSport_en
    case 'JO_ShootingParaSport_fr':
      return JO_ShootingParaSport_fr
    case 'JO_Shooting_en':
      return JO_Shooting_en
    case 'JO_Shooting_fr':
      return JO_Shooting_fr
    case 'JO_SittingVolleyball_en':
      return JO_SittingVolleyball_en
    case 'JO_SittingVolleyball_fr':
      return JO_SittingVolleyball_fr
    case 'JO_Skateboarding_en':
      return JO_Skateboarding_en
    case 'JO_Skateboarding_fr':
      return JO_Skateboarding_fr
    case 'JO_SportClimbing_en':
      return JO_SportClimbing_en
    case 'JO_SportClimbing_fr':
      return JO_SportClimbing_fr
    case 'JO_Swimming_en':
      return JO_Swimming_en
    case 'JO_Swimming_fr':
      return JO_Swimming_fr
    case 'JO_TableTennis_en':
      return JO_TableTennis_en
    case 'JO_TableTennis_fr':
      return JO_TableTennis_fr
    case 'JO_Taekwondo_en':
      return JO_Taekwondo_en
    case 'JO_Taekwondo_fr':
      return JO_Taekwondo_fr
    case 'JO_Tennis_en':
      return JO_Tennis_en
    case 'JO_Tennis_fr':
      return JO_Tennis_fr
    case 'JO_Trampoline_en':
      return JO_Trampoline_en
    case 'JO_Trampoline_fr':
      return JO_Trampoline_fr
    case 'JO_Triathlon_en':
      return JO_Triathlon_en
    case 'JO_Triathlon_fr':
      return JO_Triathlon_fr
    case 'JO_Volleyball_en':
      return JO_Volleyball_en
    case 'JO_Volleyball_fr':
      return JO_Volleyball_fr
    case 'JO_WaterPolo_en':
      return JO_WaterPolo_en
    case 'JO_WaterPolo_fr':
      return JO_WaterPolo_fr
    case 'JO_Weightlifting_en':
      return JO_Weightlifting_en
    case 'JO_Weightlifting_fr':
      return JO_Weightlifting_fr
    case 'JO_WheelchairBasketball_en':
      return JO_WheelchairBasketball_en
    case 'JO_WheelchairBasketball_fr':
      return JO_WheelchairBasketball_fr
    case 'JO_WheelchairFencing_en':
      return JO_WheelchairFencing_en
    case 'JO_WheelchairFencing_fr':
      return JO_WheelchairFencing_fr
    case 'JO_WheelchairRugby_en':
      return JO_WheelchairRugby_en
    case 'JO_WheelchairRugby_fr':
      return JO_WheelchairRugby_fr
    case 'JO_WheelchairTennis_en':
      return JO_WheelchairTennis_en
    case 'JO_WheelchairTennis_fr':
      return JO_WheelchairTennis_fr
    case 'JO_Wrestling_en':
      return JO_Wrestling_en
    case 'JO_Wrestling_fr':
      return JO_Wrestling_fr
    default:
      return null
  }
}

export const SuggestEventSvg = ({ iconName }) => {
  const icon = getSvgFromName(iconName)
  return icon ? <SVGIcon url={icon} /> : <></>
}
